import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/schology/client-back.webp";

function Projectinsightsschology() {
  return (
    <section className="project-insights-schology p-100 text_white">
      <Container className="h-100">
        <div
          className="insights-box"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Row className="h-100 align-items-center">
            <Col xs={12} md={8} lg={7} xl={6} xxl={6} className="mb-4 mb-md-0">
              <h2>
                Client & <span className="white-box">Project Insight</span>
              </h2>
              <h3 style={{ color: "#fff" }}>
                TekRevol’s Role in Empowering Schools with Schology
              </h3>
              <p>
                The client identified a gap in the education system with no
                unified digital platform for schools to manage resources,
                communicate with parents, and track student progress. They
                envisioned Schology as a multi-tenant hub that would connect
                students, teachers, parents, and administrators, and partnered
                with TekRevol to bring it to life.
              </p>
              <ul>
                <li>
                  <strong>Industry</strong>: Education
                </li>
                <li>
                  <strong>Business Type</strong>: Educational Platform
                </li>
                <li>
                  <strong>Services Provided</strong>: App Development, UI/UX
                  Design, Backend Development, Data Management, Parent
                  Engagement
                </li>
              </ul>
            </Col>
            <Col
              xs={12}
              md={4}
              lg={5}
              xl={5}
              xxl={5}
              className="mt-auto text-center offset-xl-1"
            >
              <StaticImage
                src="../../../images/case-studies/schology/client-insights-img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={409}
                height={372}
              />
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Projectinsightsschology;
